import React from "react";
import { RouteComponentProps } from "@reach/router";
import Shell from "./Shell";

const DeleteAccount: React.FC<RouteComponentProps> = () => {
  return (
    <Shell>
      <div className="container mx-auto my-4">
        <div className="forecast-wrapper">
          <div>
            <h1 className="text-4xl mb-4">Delete account</h1>
            <p className="mb-4">
              To delete your account, please email me at{" "}
              <a
                href="mailto:steven@musumeche.com"
                className="text-blue-500 underline"
              >
                steven@musumeche.com
              </a>{" "}
              and I'll take care of it for you.
            </p>
          </div>
        </div>
      </div>
    </Shell>
  );
};

export default DeleteAccount;
